import { useState } from "react"

export function CopyableText({ text }: { text: string }) {
   const [copied, setCopied] = useState(false)

   const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation()
      navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 1000)
   }

   return (
      <button
         onClick={handleClick}
         className="btn btn-sm btn-ghost font-normal relative"
         title="Cliquer pour copier"
      >
         <span className={copied ? "invisible" : "visible"}>{text}</span>
         {copied && (
            <span className="absolute inset-0 flex items-center justify-center text-success">
               Copié !
            </span>
         )}
      </button>
   )
}
